import { createFileRoute, redirect } from "@tanstack/react-router";

import { VerifyEmailStep } from "~/pages/onboard/steps/verify-email-step";

/**
 * Personal onboarding step inserted between `user` and
 * `invitations`/`workspace` for email-signup users whose `emailVerified`
 * column is still `false`. Strict gate -- only renders when the user is
 * actively at this step. Google OAuth signups skip it because they arrive
 * with `emailVerified === true`.
 */
export const Route = createFileRoute("/onboard/verify-email")({
  beforeLoad: ({ context }) => {
    if (context.user?.onboarding !== "verifyEmail") {
      throw redirect({ to: "/onboard", replace: true });
    }
  },
  component: VerifyEmailStep,
});
